// Saans Wellness brand identity.
// Minimal sprout (new growth / breath) beneath a fine breath-arc, paired with an
// elegant Playfair "Saans" wordmark, "WELLNESS" with hairline rules, and the
// tagline "Breathe Better. Live Better." Variants: icon | horizontal | vertical.

export function LogoIcon({ size = 40, className = "", arc = "currentColor", sprout = "#1f5d3a" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 80 72" fill="none" className={className} aria-hidden="true">
      {/* breath arc */}
      <path d="M18 34 A 22 22 0 1 1 62 34" stroke={arc} strokeWidth="2" strokeLinecap="round" fill="none" />
      {/* stem */}
      <path d="M40 52 C 40 44, 40 38, 40 30" stroke={sprout} strokeWidth="2" strokeLinecap="round" />
      {/* left leaf */}
      <path d="M40 40 C 33 40, 28 36, 28.5 29 C 35 29.5, 39.5 33, 40 40 Z" stroke={sprout} strokeWidth="1.8" strokeLinejoin="round" fill="none" />
      {/* right leaf (slightly higher) */}
      <path d="M40 37 C 47 37, 52.5 32.5, 52 25 C 45 25.5, 40.5 30, 40 37 Z" stroke={sprout} strokeWidth="1.8" strokeLinejoin="round" fill="none" />
    </svg>
  );
}

export default function Logo({
  variant = "horizontal",
  wordColor = "#1c1a17",
  subColor = "#d46a1d",
  taglineColor = "#8a8880",
  arcColor = "#1c1a17",
  sproutColor = "#1f5d3a",
  className = "",
}) {
  if (variant === "icon") {
    return <LogoIcon size={40} className={className} arc={arcColor} sprout={sproutColor} />;
  }

  if (variant === "vertical") {
    return (
      <span className={`flex flex-col items-center text-center ${className}`}>
        <LogoIcon size={50} arc={arcColor} sprout={sproutColor} />
        <span className="-mt-1 font-display text-4xl leading-none tracking-tight">
          <span style={{ color: wordColor }}>Saans</span>{" "}
          <span className="italic" style={{ color: subColor }}>Wellness</span>
        </span>
        <span className="mt-1.5 font-sans text-[0.62rem] font-medium uppercase tracking-[0.3em]" style={{ color: taglineColor }}>
          Breathe Better. Live Better.
        </span>
      </span>
    );
  }

  // horizontal (default) — "Saans Wellness" inline, Wellness in orange
  return (
    <span className={`flex items-center gap-3 ${className}`}>
      <LogoIcon size={46} arc={arcColor} sprout={sproutColor} />
      <span className="font-display text-[1.9rem] leading-none tracking-tight">
        <span style={{ color: wordColor }}>Saans</span>{" "}
        <span className="italic" style={{ color: subColor }}>Wellness</span>
      </span>
    </span>
  );
}
